
export type TweetFeedResponseTweetsItemMediaItemType = typeof TweetFeedResponseTweetsItemMediaItemType[keyof typeof TweetFeedResponseTweetsItemMediaItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetFeedResponseTweetsItemMediaItemType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
} as const;
